import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';
import { Breadcrumb } from 'src/components/Breadcrumb';
import { CollapsingTabScrollButton, SectionHeading } from 'src/UIKit';
import { useEditCompanyViewController } from '../../controllers/EditCompanyViewController';
import BrandInfoTab from './BrandInfoTab';
import CampaignInfoTab from './CampaignInfoTab';
import CompanyDocumentsTab from './CompanyDocumentsTab';
import CompanyInfoTab from './CompanyInfoTab';
import CompanyPhonesTab from './CompanyPhonesTab';
import CompanySubscriptionTab from './CompanySubscriptionTab';

type TabPanelProps = {
  children?: React.ReactNode;
  name: string;
  value: string;
};

const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, name, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== name}
      id={`simple-tabpanel-${name}`}
      aria-labelledby={`simple-tab-${name}`}
      {...other}
    >
      {value === name && <>{children}</>}
    </div>
  );
};

const getProps = (name: string) => {
  return {
    id: `simple-tab-${name}`,
    'aria-controls': `simple-tabpanel-${name}`,
  };
};

export const EditCompanyView = () => {
  const { profile, company, tab, isAllowed, refreshCompany, handleTabChange } =
    useEditCompanyViewController();

  if (!isAllowed) {
    return null;
  }

  return (
    <>
      {profile && company && (
        <Box width="100%">
          <SectionHeading component="div">
            <Breadcrumb
              items={[
                { label: 'Companies', path: '/admin/companies' },
                { label: company.name, isActive: true },
              ]}
            />
          </SectionHeading>
          <Tabs
            sx={{ mt: 3.75 }}
            value={tab}
            onChange={handleTabChange}
            aria-label="editCompany tab"
            ScrollButtonComponent={CollapsingTabScrollButton}
            scrollButtons="auto"
          >
            <Tab label="Company Info" value="info" {...getProps('info')} />
            <Tab label="Brand Info" value="brand" {...getProps('brand')} />
            <Tab label="Campaign Info" value="campaign" {...getProps('campaign')} />
            <Tab label="Subscription" value="subscription" {...getProps('subscription')} />
            <Tab label="Phones" value="phones" {...getProps('phones')} />
            <Tab label="Documents" value="documents" {...getProps('documents')} />
          </Tabs>
          <CustomTabPanel value={tab} name="info">
            <CompanyInfoTab company={company} refreshCompany={refreshCompany} />
          </CustomTabPanel>
          <CustomTabPanel value={tab} name="brand">
            <BrandInfoTab company={company} refreshCompany={refreshCompany} />
          </CustomTabPanel>
          <CustomTabPanel value={tab} name="campaign">
            <CampaignInfoTab company={company} refreshCompany={refreshCompany} />
          </CustomTabPanel>
          <CustomTabPanel value={tab} name="subscription">
            <CompanySubscriptionTab company={company} refreshCompany={refreshCompany} />
          </CustomTabPanel>
          <CustomTabPanel value={tab} name="phones">
            <CompanyPhonesTab company={company} refreshCompany={refreshCompany} />
          </CustomTabPanel>
          <CustomTabPanel value={tab} name="documents">
            <CompanyDocumentsTab companyId={company.id} company={company} />
          </CustomTabPanel>
        </Box>
      )}
    </>
  );
};
